import React from 'react';
import styles from './Table.module.scss';
import { getTranslation } from '../../../utils/translation';
import { useDispatch, useSelector } from 'react-redux';
import { getMessageDetails } from '../../../store/actions/messages';
import moment from 'moment';
import Status from '../../shared/Status/Status';
import { MESSAGE_PRIORITIES } from '../../../constants/defaultValues';
import { changeMessageModalProps } from '../../../store/actions/modals';

const Table = () => {
    const dispatch = useDispatch();

    const messagesList = useSelector(state => state.messages.messagesList);

    const onDetailsClick = message => {
        dispatch(getMessageDetails(message.id));
        dispatch(
            changeMessageModalProps({
                isVisible: true,
                isNewMessage: message.messageStatus === 1,
            })
        );
    };

    const getPriorityLabel = id =>
        MESSAGE_PRIORITIES.find(priority => priority.value === id)?.label || id;

    const getStatusProps = statusId => {
        const statusProps = {};

        if (statusId === 1) {
            statusProps.status = 'success';
            statusProps.icon = 'icon-unread';
            statusProps.title = getTranslation('messagesTableRowMessageStatusNew');
        } else if (statusId === 2) {
            statusProps.status = 'warning';
            statusProps.icon = 'icon-saved';
            statusProps.title = getTranslation('messagesTableRowMessageStatusSaved');
        } else if (statusId === 3) {
            statusProps.status = 'neutral';
            statusProps.icon = 'icon-read';
            statusProps.title = getTranslation('messagesTableRowMessageStatusRead');
        }

        return statusProps;
    };

    const renderBodyRows = (item, index) => {
        return (
            <tr align='center' key={index}>
                <td className={styles.numberCell}>{index + 1}</td>
                <td>
                    <Status {...getStatusProps(item.messageStatus)} />
                </td>
                <td>{getPriorityLabel(item.priorityStatus)}</td>
                <td>{item.id}</td>
                <td>{item.title}</td>
                <td>{moment(item.created).format('DD/MM/YYYY HH:mm:ss')}</td>
                <td>
                    <button className={styles.detailsBtn} onClick={() => onDetailsClick(item)}>
                        <span>{getTranslation('messagesTableRowMore')}</span>
                        <span className='icon-arrow-down' />
                    </button>
                </td>
            </tr>
        );
    };

    return (
        <table className={styles.table}>
            <thead>
                <tr align='center'>
                    <th>{getTranslation('messagesTableColumnsNo')}</th>
                    <th>{getTranslation('messagesTableColumnsType')}</th>
                    <th>{getTranslation('')}</th>
                    <th>{getTranslation('messagesTableColumnsMessageId')}</th>
                    <th>{getTranslation('messagesTableColumnsMessage')}</th>
                    <th>{getTranslation('messagesTableColumnsDate')}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {messagesList.length > 0 &&
                    messagesList.map((message, index) => renderBodyRows(message, index))}
            </tbody>
        </table>
    );
};

export default Table;
